import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class FarmoutConfigurationService {

  constructor(private http: HttpClient) {
  }

  getConfigurationList() {
    return this.http.get<any>(urls.BASE_URL + urls.FARMOUT_CONFIG_URL)
      .pipe(
        catchError(errorHandl)
      )
  }


  addFarmoutConfiguration(payload: any) {

    return this.http.post(urls.BASE_URL + urls.FARMOUT_CONFIG_URL, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  updateFarmoutConfiguration(id, payload: any) {

    return this.http.put(urls.BASE_URL + urls.FARMOUT_CONFIG_URL + '/' + id, payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getFarmoutConfigurationById(configurationId: any) {
    return this.http.get<any>(urls.BASE_URL + urls.FARMOUT_CONFIG_URL + '/' + configurationId)
      .pipe(
        catchError(errorHandl)
      )
  }

}
